'use client'

import '@packages/ui-library/styles/theme/shared.scss'

import { HOME_INDEX } from '@lib/routes'
import { SharedGlobalError } from '@packages/ui-library'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return <SharedGlobalError homeUrl={HOME_INDEX} title="Search" error={error} />
}
